import React from 'react';

import {
  PeoPayrollProviderStaffsListQueryVariables,
  usePeoPayrollProviderStaffsListQuery,
} from 'src/api';

export const usePeoPayrollProviderStaffsList = (
  variables?: PeoPayrollProviderStaffsListQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = usePeoPayrollProviderStaffsListQuery({
    variables,
    notifyOnNetworkStatusChange,
  });

  const peoPayrollProviderStaffsList = React.useMemo(
    () => data?.peoPayrollProviderStaffList ?? [],
    [data?.peoPayrollProviderStaffList],
  );

  const peoPayrollProviderStaffsCount = React.useMemo(
    () => data?.peoPayrollProviderStaffCount ?? 0,
    [data?.peoPayrollProviderStaffCount],
  );

  return {
    peoPayrollProviderStaffsList,
    peoPayrollProviderStaffsCount,
    refetch,
    loading,
  };
};
